import React, { memo } from 'react';
import { StyleSheet, View } from 'react-native';
import useColors from 'hooks/useColors';
import { rem } from './values';
import Squircle from './Squircle';
import IconCheck from './icons/IconCheck';
import BorderedSquircle from './BorderedSquircle';
const RadioButton = ({ style, type, isChecked, testID, disabled, }) => {
    const colors = useColors();
    return (<View style={style} testID={testID}>
      <BorderedSquircle size={24} borderStrokeProps={{
            stroke: isChecked
                ? colors.elements.brand
                : colors.cards.transparentOnDark,
        }} color={isChecked ? colors.background.light : colors.background.brandLight} style={disabled ? styles.disabled : undefined}>
        {!!isChecked &&
            (type === 'multiple' ? (<IconCheck width={rem(16)} thick color={colors.elements.brand}/>) : (<Squircle width={rem(14)} height={rem(14)} color={colors.elements.brand}/>))}
      </BorderedSquircle>
    </View>);
};
const styles = StyleSheet.create({
    disabled: { opacity: 0.5 },
});
export default memo(RadioButton);
